import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoLogReenviosComponent } from './listado-log-reenvios/listado-log-reenvios.component';

const routes: Routes = [
  { path: '', component: ListadoLogReenviosComponent },
  // {
  //   path: 'detalles/:id',
  //   component: DetallesMantenimientoComponent,
  //   canActivate: [],
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LogReenviosRoutingModule {}
